import React from 'react';
import { useTranslation } from 'react-i18next';

import ConfirmModal from '../../../../../components/modals/ConfirmModal';
import * as events from '../../../../../lib/analytics/events';
import styles from '../../../styles/SubscriptionContainer.module.scss';
import { DateTime } from 'luxon';

interface ICancelConfirmationModalProps {
  onContinue: () => void;
  trigger: React.ReactElement;
  selectedReason: string;
  nextBillDate: string | null;
}

export default function CancelConfirmationModal({
  onContinue,
  trigger,
  selectedReason,
  nextBillDate,
}: ICancelConfirmationModalProps) {
  const { t } = useTranslation();
  const onAccept = () => {
    events.airvetManagement.cancellation.cancelConfirmationModalContinue(selectedReason);
    onContinue();
  };
  const onDecline = () => {
    events.airvetManagement.cancellation.cancelConfirmationModalCancel();
  };

  return (
    <ConfirmModal
      trigger={trigger}
      body={
        <>
          <div className={styles.header}>
            <h3>{t('are_you_sure')}</h3>
          </div>
          <p>
            {t('you_will_no_longer_have_access_to_your_airvet_account_after_date', {
              date: nextBillDate ? DateTime.fromISO(nextBillDate).toFormat('LLLL d, yyyy') : t('your_next_bill_date'),
            })}
          </p>
        </>
      }
      acceptText={t('yes_cancel_airvet_membership')}
      declineText={t('nevermind_go_back')}
      onAccept={onAccept}
      onDecline={onDecline}
    />
  );
}
